import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "none",
  viewBox: "0 0 76 76"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFC300",
      d: "M55.087 12.175H20.913a8.444 8.444 0 0 0-8.444 8.444v34.35a8.444 8.444 0 0 0 8.444 8.444h34.174a8.444 8.444 0 0 0 8.444-8.445V20.62a8.444 8.444 0 0 0-8.444-8.444"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#1D1728",
      d: "M28.53 66.259c1.909 2.063 4.838 2.616 7.648 2.616h5.578c2.81 0 5.74-.553 7.647-2.616.786-.85 1.46-1.806 2.002-2.846h-7.146a7.3 7.3 0 0 1-4.325 1.414H38a7.3 7.3 0 0 1-4.326-1.414h-7.145a13 13 0 0 0 2.002 2.846M29.667 7.125c-1.46 0-2.978.537-3.533 1.885a5.8 5.8 0 0 0-.439 2.225v35.687c0 6.743 5.492 12.37 12.204 12.372 6.738.004 12.217-5.5 12.217-12.266V24.62a3.69 3.69 0 0 0-1.07-2.596 3.65 3.65 0 0 0-2.583-1.075H43.26a1.45 1.45 0 0 0-1.347.904 1.5 1.5 0 0 0-.11.56v2.654c0 .388.153.76.426 1.035.274.274.644.428 1.03.428h1.301v20.424c0 3.689-2.944 6.738-6.616 6.76a6.64 6.64 0 0 1-4.729-1.947 6.7 6.7 0 0 1-1.964-4.74V11.236a.24.24 0 0 1 .236-.238h16.19a.236.236 0 0 1 .236.238v.94h5.555v-.94a5.8 5.8 0 0 0-.437-2.224c-.554-1.349-2.071-1.886-3.53-1.886z"
    }, null, -1)
  ]))]))
}
export default { render: render }